import { render, staticRenderFns } from "./reportsMainView.vue?vue&type=template&id=a47cee44&scoped=true"
import script from "./reportsMainView.vue?vue&type=script&lang=js"
export * from "./reportsMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47cee44",
  null
  
)

export default component.exports